import { defineComponent as _defineComponent } from 'vue'
import { useForm } from '@/util/useForm';
import { computed, onMounted, reactive, ref } from 'vue';
import { message } from 'ant-design-vue';
import moment from 'moment';
import { useRoute } from '@/router';


export default /*#__PURE__*/_defineComponent({
  __name: 'DiscountForm',
  props: {
    edit: null
  },
  emits: ['getData'],
  setup(__props: any, { expose, emit }) {

const props = __props as {
  edit: any;
};

const form = useForm();
const labelCol = reactive({
  xs: { span: 24 },
  sm: { span: 7 },
});
const wrapperCol = reactive({
  xs: { span: 20 },
  sm: { span: 12 },
});


const inputLength = ref<number>();
const discount = ref<number>(props.edit.type || 1); // 单选（满减 / 满折）
const overlay = ref<number>(props.edit.superposition || 1);
const isNext = ref<boolean>(false);
const formValue = ref<any>();
const isEdit = ref<any>(false); // 编辑 / 新建
const startTime = ref<any>(); // 开始时间
const endTime = ref<any>(); // 结束时间
const route = useRoute();

// 输入框
function inputChange(e) {
  inputLength.value = e.target.value.length;
}
function getFormData() {
  form.value.validateFields((err, val) => {
    if (val.dis_money_1 < val.dis_reduce_1) {
      return message.error('优惠金额不能大于活动的消费金额');
    }
    if (!err) {
      isNext.value = true;
      if (discount.value == 1) {
        formValue.value = {
          name: val.active_name,
          type: discount.value,
          start_time: +moment(val.start_time).format('X'),
          end_time: +moment(val.end_time).format('X'),
          threshold_price: val.dis_money_1 * 100,
          discounts_minus: val.dis_reduce_1 * 100,
          overlay: overlay.value,
        };
      } else {
        formValue.value = {
          name: val.active_name,
          type: discount.value,
          start_time: +moment(val.start_time).format('X'),
          end_time: +moment(val.end_time).format('X'),
          threshold_price: val.dis_money_2 * 100,
          discounts_ratio: val.dis_reduce_2 * 10,
          overlay: overlay.value,
        };
      }
      emit('getData', formValue.value);
    }
  });
}
function auto() {
  if (discount.value == 2) {
    overlay.value = 2;
  }
}
// 限制开始时间不得早于今天
function disabledStartDate(current) {
  const now = moment().subtract(1, 'day');
  let isPre = false;
  if (!isEdit.value) {
    if (!current) {
      isPre = false;
    }
    isPre = current.valueOf() <= now.valueOf();
  }
  if (!isPre) {
    if (!current || !endTime.value) {
      return false;
    }
    return current.valueOf() > endTime.value.valueOf();
  }
  return isPre;
}
// 限制结束时间不得早于开始时间
function disabledEndDate(current) {
  if (!current || !startTime.value) {
    return false;
  }
  return startTime.value.valueOf() >= current.valueOf();
}
function getStartTime(current) {
  startTime.value = current;
}
function getEndTime(current) {
  endTime.value = current;
}
onMounted(() => {
  if (route.name == 'EditDiscount') {
    isEdit.value = true;
    startTime.value = moment(props.edit.start_time * 1000);
  } else {
    isEdit.value = false;
  }
  // console.log('start', startTime.value.valueOf());
});
expose({
  getFormData,
});

return { __sfc: true,form, labelCol, wrapperCol, props, emit, inputLength, discount, overlay, isNext, formValue, isEdit, startTime, endTime, route, inputChange, getFormData, auto, disabledStartDate, disabledEndDate, getStartTime, getEndTime, moment }
}

})